import { IconBase, IconBaseProps } from 'react-icons';

export function WarningIcon(props: IconBaseProps) {
    return (
        <IconBase {...props} viewBox="0 0 18 18">
            <path
                d="M9 5.8V9M9 12.2H8.992M1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}
